import { AutocompleteInput } from "react-admin";
import { normalizeSearch } from "./searchNormalize";

const labelOf = (choice, optionText) => {
  if (!choice) {
    return "";
  }
  if (typeof optionText === "function") {
    return String(optionText(choice) ?? "");
  }
  if (typeof optionText === "string") {
    return String(choice[optionText] ?? "");
  }
  return String(choice.name ?? choice.nameBg ?? "");
};

const DormitoryAutocompleteInput = ({
  optionText = "name",
  filterToQuery = q => (q?.trim().length > 2 ? { name: q.trim() } : {}),
  matchSuggestion,
  noOptionsText = "Няма резултати",
  ...props
}) => (
  <AutocompleteInput
    optionText={optionText}
    filterToQuery={filterToQuery}
    noOptionsText={noOptionsText}
    matchSuggestion={
      matchSuggestion ??
      ((filter, choice) =>
        !filter?.trim() || normalizeSearch(labelOf(choice, optionText)).includes(normalizeSearch(filter)))
    }
    {...props}
  />
);

export default DormitoryAutocompleteInput;
